/*
 * @Author: qin 15936669602@163.com
 * @Date: 2024-02-01 11:42:34
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-08-17 09:39:23
 * @FilePath: /360-house-viewing-main/src/api/manage/content.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

// 查询内容管理-场景内容列表
export function listContent(query) {
  return request({
    url: "/manage/content/list",
    method: "get",
    params: query,
  });
}

// 查询内容管理-场景内容详细
export function getContent(id) {
  return request({
    url: "/manage/content/" + id,
    method: "get",
  });
}

// 新增内容管理-场景内容
export function addContent(data) {
  return request({
    url: "/manage/content",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  });
}

// 修改内容管理-场景内容
export function updateContent(data) {
  return request({
    url: "/manage/content",
    method: "put",
    data: data,
  });
}

// 删除内容管理-场景内容
export function delContent(id) {
  return request({
    url: "/manage/content/" + id,
    method: "delete",
  });
}

export function uploadScene(data) {
  return request({
    url: "/manage/content/uploadScene",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

// 新增内容管理-场景内容
export function addCaseContent(data, method = "post") {
  return request({
    url: "/manage/case",
    method,
    data,
  });
}
